import { gql, useQuery as useGQLQuery } from '@apollo/client';

import { getAccessToken } from 'helpers/account';

enum OrganizationFilter {
  ANY = 'ANY',
  OPEN = 'OPEN',
  CURRENT = 'CURRENT',
}

export const IS_ACCOUNT_WHITELISTED = gql`
  query IsAccountWhitelisted($filter: OrganizationFilter, $organization_id: String) {
    IsAccountWhitelisted(filter: $filter, organization_id: $organization_id)
  }
`;

interface IUseGetIsAccountWhitelisted {
  isAccountWhitelisted: boolean;
  isFetching: boolean;
}

export const useGetIsAccountWhitelisted = (): IUseGetIsAccountWhitelisted => {
  const { data: whitelistData, loading } = useGQLQuery<{ IsAccountWhitelisted: boolean }>(
    IS_ACCOUNT_WHITELISTED,
    {
      context: {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      },
    }
  );

  return {
    isAccountWhitelisted: whitelistData?.IsAccountWhitelisted,
    isFetching: loading,
  };
};

interface IUseGetIsAccountWhitelistedElsewhere {
  isAccountWhitelistedElsewhere: boolean;
  isFetching: boolean;
}

export const useGetIsAccountWhitelistedElsewhere = (): IUseGetIsAccountWhitelistedElsewhere => {
  const { data: whitelistData, loading } = useGQLQuery<{ IsAccountWhitelisted: boolean }>(
    IS_ACCOUNT_WHITELISTED,
    {
      variables: { filter: OrganizationFilter.OPEN },
      context: {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      },
    }
  );

  return {
    isAccountWhitelistedElsewhere: whitelistData?.IsAccountWhitelisted,
    isFetching: loading,
  };
};

interface IUseGetIsAccountWhitelistedInOrg {
  isAccountWhitelistedInOrg: boolean;
  isFetching: boolean;
}

export const useGetIsAccountWhitelistedInOrg = (
  organizationId: string
): IUseGetIsAccountWhitelistedInOrg => {
  const { data: whitelistData, loading } = useGQLQuery<{ IsAccountWhitelisted: boolean }>(
    IS_ACCOUNT_WHITELISTED,
    {
      variables: { filter: OrganizationFilter.CURRENT, organization_id: organizationId },
      context: {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      },
    }
  );

  return {
    isAccountWhitelistedInOrg: whitelistData?.IsAccountWhitelisted,
    isFetching: loading,
  };
};
